const menuItems = document.querySelectorAll<HTMLLIElement>(".nav-has-dropdown");

const expandSubMenu = (item: HTMLLIElement) => {
  const subMenu = item.querySelector<HTMLUListElement>(".nav-dropdown");
  const button = item.querySelector<HTMLButtonElement>(".dropdown-toggle");
  const parentItem = item.closest<HTMLLIElement>(".nav-has-dropdown");
  const openSiblings =
    item.parentElement?.querySelectorAll<HTMLLIElement>(".nav-has-dropdown.open");

  openSiblings?.forEach((sibling) => {
    if (sibling !== item) {
      collapseSubMenu(sibling);
    }
  });

  if (subMenu && button && parentItem) {
    subMenu.setAttribute("aria-hidden", "false");
    button.setAttribute("aria-expanded", "true");
    parentItem.classList.add("open");
  }
};

const collapseSubMenu = (item: HTMLLIElement) => {
  const subMenu = item.querySelector<HTMLUListElement>(".nav-dropdown");
  const button = item.querySelector<HTMLButtonElement>(".dropdown-toggle");
  const parentItem = item.closest<HTMLLIElement>(".nav-has-dropdown");

  if (subMenu && button && parentItem) {
    subMenu.setAttribute("aria-hidden", "true");
    button.setAttribute("aria-expanded", "false");
    parentItem.classList.remove("open");
  }
};

menuItems.forEach((item) => {
  const button = item.querySelector<HTMLButtonElement>("button");
  if (!button) return;

  button.addEventListener("pointerdown", () => {
    if (button.getAttribute("aria-expanded") === "false") {
      expandSubMenu(item);
    } else {
      collapseSubMenu(item);
    }
  });

  item.addEventListener("pointerenter", (event) => {
    if (event.pointerType !== "mouse") return;
    expandSubMenu(item);
  });

  item.addEventListener("pointerleave", (event) => {
    if (event.pointerType !== "mouse") return;
    collapseSubMenu(item);
  });

  button.addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (button.getAttribute("aria-expanded") === "false") {
        expandSubMenu(item);
      } else {
        collapseSubMenu(item);
      }
    }
  });

  // when submenu loses focus, collapse it
  item.addEventListener("focusout", (event: FocusEvent) => {
    const relatedTarget = event.relatedTarget as HTMLElement;
    if (!item.contains(relatedTarget)) {
      collapseSubMenu(item);
    }
  });
});
